import { useMutation } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { stopImpersonatingSchema } from './schemas';

export const useStopImpersonating = () => {
  return useMutation({
    mutationFn: () =>
      fetchJson('/authentication/stop-impersonating', {
        method: 'POST',
        schema: stopImpersonatingSchema,
      }),
    onSuccess: ({ redirect }) => {
      window.location.href = redirect;
    },
  });
};
